import { Check } from "lucide-react";
import { Reveal } from "./Reveal";

const APP_TYPES = [
    "Custom CRM systems",
    "Booking & scheduling apps",
    "Customer portals",
    "E-commerce stores",
    "Internal dashboards",
    "Inventory & delivery management",
    "Document & mail workflows",
    "Marketing websites",
];

const POINTS = [
    "Custom solutions built around your workflow",
    "Free, no-commitment discovery calls before any project",
    "Plain-language communication — no tech jargon",
    "Flexible scheduling — life happens",
];

export const About = () => (
    <section id="about" data-testid="about-section" className="py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-5 md:px-10 grid md:grid-cols-2 gap-12 md:gap-20 items-center">
            <Reveal className="order-2 md:order-1">
                <div className="overflow-hidden">
                    <img
                        src="/assets/alex.png"
                        alt="Alex Hudson, founder of Consulting WorX"
                        data-testid="about-image"
                        className="w-full h-[50vh] md:h-[65vh] object-cover object-top hover:scale-[1.02] transition-transform duration-700"
                    />
                </div>
                <p className="mt-4 text-xs text-ink/40 tracking-wide uppercase">Alex Hudson · Founder & Developer</p>
            </Reveal>
            <Reveal delay={0.1} className="order-1 md:order-2">
                <p className="flex items-center gap-3 text-xs md:text-sm tracking-[0.25em] uppercase text-ink/50">
                    <span className="h-px w-10 bg-worx inline-block" /> About Consulting WorX
                </p>
                <h2 className="mt-6 font-display font-semibold tracking-tighter leading-[0.95] text-4xl md:text-6xl">
                    Your business isn't off-the-shelf. Your software shouldn't be either.
                </h2>
                <p className="mt-10 text-xs md:text-sm tracking-[0.25em] uppercase text-ink/50">Meet your developer</p>
                <h3 className="mt-2 font-display font-medium text-2xl md:text-3xl tracking-tight" data-testid="about-instructor-name">
                    Alex Hudson
                </h3>
                <p className="mt-4 text-ink/70 leading-relaxed text-base md:text-lg" data-testid="about-bio">
                    Alex is a specialist in custom website and application development, with deep expertise in
                    building tailored CRM (Customer Relationship Management) systems for a variety of business
                    needs — from delivery scheduling and document workflows to e-commerce with Square and Stripe
                    integrations.
                </p>
                <p className="mt-5 text-xs uppercase tracking-[0.2em] text-ink/50">What I can build for you</p>
                <div className="mt-3 flex flex-wrap gap-2" data-testid="about-app-types">
                    {APP_TYPES.map((t) => (
                        <span key={t} className="border border-ink/10 bg-white px-3 py-1.5 text-sm text-ink/80">
                            {t}
                        </span>
                    ))}
                </div>
                <p className="mt-5 text-ink/70 leading-relaxed">
                    Whether you need a website that books clients, an app that manages your workflow, or an
                    e-commerce solution that connects to your existing payment systems, Alex delivers real software
                    that matches how you actually work — with a focus on security, scalability, and practical
                    solutions that grow alongside your company, without the cost or complexity of agency projects.
                </p>
                <p className="mt-4 text-ink/70 leading-relaxed">
                    Alex holds a Bachelor's degree from Southern New Hampshire University (SNHU) and brings
                    extensive experience with the latest AI technologies, including social media content creation
                    and automation. As an AI CRM developer, Alex is committed to continuous learning — mastering
                    emerging platforms early, then translating that knowledge into working solutions and clear,
                    actionable guidance for clients.
                </p>
                <p className="mt-4 text-ink/70 leading-relaxed">
                    Consulting WorX is dedicated to small business owners, freelancers, and busy professionals who
                    want expert-built software — no agency prices, no endless video tutorials. You get:
                </p>
                <ul className="mt-6 space-y-3">
                    {POINTS.map((p) => (
                        <li key={p} className="flex items-start gap-3 text-ink/80">
                            <Check size={18} className="text-worx mt-0.5 shrink-0" />
                            <span>{p}</span>
                        </li>
                    ))}
                </ul>
            </Reveal>
        </div>
    </section>
);
